<template>
  <div class="progress-circle">
    <svg :width="width" :height="width">
      <circle
        :cx="width / 2"
        :cy="width / 2"
        :r="r"
        :stroke-width="stroke"
        :stroke-dasharray="`${c} ${c}`"
        :stroke="trackColor"
        fill="transparent"
      />
      <circle
        :cx="width / 2"
        :cy="width / 2"
        :r="r"
        :stroke-width="stroke"
        :stroke-dasharray="`${c} ${c}`"
        :stroke-dashoffset="progress"
        :stroke="progressColor"
        fill="transparent"
      />
    </svg>
    <div class="progress-circle__text">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Number,
    width: {
      type: Number,
      default: 150
    },
    stroke: {
      type: Number,
      default: 12
    },
    progressColor: {
      type: String,
      default: "var(--primary)"
    },
    trackColor: {
      type: String,
      default: "var(--gray)"
    }
  },

  computed: {
    /** @returns {Number} */
    r() {
      return this.width / 2 - this.stroke;
    },
    /** @returns {Number} */
    c() {
      return 2 * Math.PI * this.r;
    },
    /** @returns {Number} */
    progress() {
      return -(1 - this.value) * this.c;
    }
  }
};
</script>

<style lang="scss">
.progress-circle {
  position: relative;
  display: inline-block;

  &__text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  circle {
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
    transition: 0.3s stroke-dashoffset;
  }
}
</style>
